/**
 * OIDC 测试项目配置
 * 注意：客户端密钥（client_secret）通常不应该在浏览器中使用
 * 这里仅用于测试目的
 */
import { UserManager, WebStorageStateStore } from 'oidc-client'

// 获取基础URL
function getBaseUrl() {
	const origin = window.location.origin
	const pathname = window.location.pathname
	return `${origin}${pathname}#`
}

// OIDC 测试配置
// 注意：client_secret 不应该在浏览器中使用（不安全）
// oidc-client 库在浏览器环境中不支持 client_secret
// 如果认证服务器要求 client_secret，需要配置为公共客户端（public client）
const oidcTestConfig = {
	authority: 'https://auth.yiqifei.com',
	client_id: '745748667101253',
	// client_secret 在浏览器中不使用，仅记录供参考
	// 实际配置需要在认证服务器端设置为公共客户端
	redirect_uri: `${getBaseUrl()}/Acccount/OidcTest/signin-oidc`,
	post_logout_redirect_uri: `${getBaseUrl()}/Acccount/OidcTest/signout-callback-oidc`,
	response_type: 'code',
	scope: 'openid profile',
	automaticSilentRenew: true,
	silent_redirect_uri: `${getBaseUrl()}/Acccount/OidcTest/silent-renew`,
	userStore: new WebStorageStateStore({ store: window.localStorage }),
	loadUserInfo: true,
	filterProtocolClaims: true
}

// 创建 UserManager 实例
const userManager = new UserManager(oidcTestConfig)

/**
 * 获取用户信息
 */
export async function getUser() {
	try {
		const user = await userManager.getUser()
		return user
	} catch (error) {
		console.error('获取用户信息失败:', error)
		return null
	}
}

/**
 * 登录
 */
export async function signinRedirect() {
	try {
		console.log('开始OIDC登录')
		console.log('认证服务器:', oidcTestConfig.authority)
		console.log('回调URL:', oidcTestConfig.redirect_uri)
		await userManager.signinRedirect()
	} catch (error) {
		console.error('登录重定向失败:', error)
		throw error
	}
}

/**
 * 处理登录回调
 */
export async function signinRedirectCallback() {
	try {
		const user = await userManager.signinRedirectCallback()
		return user
	} catch (error) {
		console.error('登录回调处理失败:', error)
		throw error
	}
}

/**
 * 登出
 */
export async function signoutRedirect() {
	try {
		await userManager.signoutRedirect()
	} catch (error) {
		console.error('登出失败:', error)
		throw error
	}
}

/**
 * 处理登出回调
 */
export async function signoutRedirectCallback() {
	try {
		await userManager.signoutRedirectCallback()
	} catch (error) {
		console.error('登出回调处理失败:', error)
		throw error
	}
}

/**
 * 检查用户是否已登录
 */
export async function isAuthenticated() {
	try {
		const user = await userManager.getUser()
		return user && !user.expired
	} catch (error) {
		console.error('检查登录状态失败:', error)
		return false
	}
}

/**
 * 移除用户（清除本地存储）
 */
export async function removeUser() {
	try {
		await userManager.removeUser()
	} catch (error) {
		console.error('移除用户失败:', error)
		throw error
	}
}

export default userManager

